import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import ColorForm from './ColorForm';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { ColorsLoader } from './ColorsLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import { Alert } from 'reactstrap';

const FileDownload = require('js-file-download');

class ManageColors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            colorInEdit: {},
            isPopupVisible: false,
            colors: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""

        };
    }

    dataStateChange = (e) => {
        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (colorsFetched) => {        
        this.setState({
            ...this.state,
            colors: colorsFetched,
            isLoading: false
        });
        if (colorsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (colorsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            colorInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i]};
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters? Filters.slice() : [] ,
            Sorts: Sorts? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageColors/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Colors.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });

        axios
            .post(`${ROOT_API_URL}/ManageColors/DeleteColor`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the color.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            colorInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageColors/SaveColor`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the color.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"colors-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading colors" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            //style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.colors.total}
                                {...this.state.dataState}
                                {...this.state.colors}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="Description" title="Description" filter="text" />
                                <Column
                                    field="IsActive"
                                    title="Is Active"
                                    width="150vw"
                                    filterable={true}
                                    filter="boolean"
                                    className="isActive-column"
                                />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <ColorsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <ColorForm
                                dataItem={this.state.colorInEdit}
                                save={this.save}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

export default ManageColors;
